import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styleObjectBlackButton } from "../common/StyleSeter";

// Measures an element's height and re-measures whenever its content changes
const useElementHeight = <T extends HTMLElement>(active: boolean) => {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!active || !ref.current) return;
    const el = ref.current;

    const update = () => setHeight(el.getBoundingClientRect().height);
    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [active]);

  return { ref, height };
};

const SkyPopup = (props: any) => {
  const {
    closeModel,
    OpenModal,
    submit,
    type,
    closebtn,
    customClass,
    isHideSubmit,
    maxWidth,
    isLoading,
  } = props;
  const DD = useSelector((e: any) => e.domainDetails);
  const menuCount = useSelector((e: any) => e.menuCount);
  const dispatch = useDispatch();
  const [isHover, setIsHover] = useState(false);

  // --- Modal height tracking ---
  const { ref: contentRef, height: modalHeight } =
    useElementHeight<HTMLDivElement>(!!OpenModal);
  const [viewportH, setViewportH] = useState(window.innerHeight);

  useEffect(() => {
    const onResize = () => setViewportH(window.innerHeight);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isOverflowing = modalHeight > viewportH;

  // Save modal height to Redux whenever it changes (and modal is open)
  useEffect(() => {
    dispatch({
      type: "SET_MODAL_HEIGHT",
      payload: OpenModal ? modalHeight : 0,
    });
  }, [dispatch, modalHeight, OpenModal]);

  const headRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!OpenModal) return;

    // Quick check: shows up as one plain line in the console
    console.log(
      `[SkyPopup] modal height = ${modalHeight}px (screen = ${viewportH}px)`,
    );

    console.group("SkyPopup height debug");
    console.log("Modal height:", modalHeight);
    console.log("Viewport height:", viewportH);
    console.log("Overflowing:", isOverflowing);
    console.table({
      header: headRef.current?.getBoundingClientRect().height ?? 0,
      body_visible: bodyRef.current?.clientHeight ?? 0,
      body_content: bodyRef.current?.scrollHeight ?? 0,
      footer: footerRef.current?.getBoundingClientRect().height ?? 0,
      modal_total: modalHeight,
      viewport: viewportH,
    });
    console.groupEnd();
  }, [OpenModal, modalHeight, viewportH, isOverflowing]);
  // --- end height tracking ---

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  console.log({ menuCount });

  return (
    <>
      <div
        className={`popup-wrp fade ${customClass ? customClass : ""} ${OpenModal ? "popup-show " : ""}`}
      >
        <div className="pop" style={maxWidth && { maxWidth: maxWidth }}>
          <div
            ref={contentRef}
            className="pop-content"
            style={{ top: menuCount > 14 ? "-26px" : "3px" }}
          >
            <div ref={headRef} className="pop-head">
              <h5 dangerouslySetInnerHTML={{ __html: props.title }}></h5>
              <div className="pop-close" onClick={closeModel}></div>
            </div>
            <form onSubmit={(e) => submit(e, type ? type : "")}>
              {/* Body scrolls if the modal is taller than the screen */}
              <div ref={bodyRef} className="pop-body">
                {props.children}
              </div>

              {!isHideSubmit && (
                <div ref={footerRef} className="pop-footer">
                  <div
                    className={`button-wrap pb-0 ${closebtn ? "d_flex d_flex_justify_spacebt d_flex_align_center w_100 " : ""}`}
                  >
                    {closebtn && (
                      <button
                        onClick={closeModel}
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    )}
                    <button
                      type="submit"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{
                        backgroundColor: "#FFB80C",
                        color: "#000",
                        border: "1px solid #000",
                        minWidth: "150px",
                        padding: "5px 10px",
                        marginTop: "12px",
                      }}
                      className="submit-btn btn btn_black btn-hover"
                      disabled={isLoading}
                    >
                      {" "}
                      {props?.btnName
                        ? props?.btnName
                        : type === "status"
                          ? "Change"
                          : "Submit"}{" "}
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkyPopup;
